
import { getNewDailyNoShowSequence, postNewDailyNoShowForm } from '../api.js'

import notifications from '../notifications.js'
import pageApiData from '../utils/pageApiData.js'

const [ _getNewDailyNoShowSequenceFromServer, _getNewDailyNoShowSequence, _getNewDailyNoShowSequenceSync ] = pageApiData.createFunctions(getNewDailyNoShowSequence, "Error loading next set of data.")

function _postNewDailyNoShowForm(content) {
  let promise = postNewDailyNoShowForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _canSubmitForm(user) {
  if (user === undefined) {
    return false
  }

  return user.can('submit_daily_no_show_form')
}

function _init() {
  // do nothing
}

_init()

export default {
  getNewDailyNoShowSequenceFromServer: _getNewDailyNoShowSequenceFromServer,
  getNewDailyNoShowSequence: _getNewDailyNoShowSequence,
  getNewDailyNoShowSequenceSync: _getNewDailyNoShowSequenceSync,

  postNewDailyNoShowForm: _postNewDailyNoShowForm,
  canSubmitForm: _canSubmitForm,
}
